module.exports = __webpack_public_path__ + "static/media/user.9891f6f2.svg";